import React, { useContext, useState, useEffect } from 'react'
import { ListGroup } from 'react-bootstrap'
import { Link, useHistory } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'

import NavGroup from './NavGroup'
import { ConfigContext } from '../../../../contexts/ConfigContext'
import * as actionType from '../../../../store/actions'
import objectPath from 'object-path'

const NavContent = ({ navigation }) => {
  const history = useHistory()
  const [activeGroupId, setActiveGroupId] = useState(null)
  const [scrollWidth, setScrollWidth] = useState(0)
  const [prevDisable, setPrevDisable] = useState(true)
  const [nextDisable, setNextDisable] = useState(false)
  const [navigationHeight, setNavigationHeight] = useState(0)
  const [isToggle, setIsToggle] = useState(false)

  const configContext = useContext(ConfigContext)
  const { dispatch } = configContext

  const { layout, rtlLayout, groupMenuId, menuClick } = configContext.state

  const scrollPrevHandler = () => {
    const wrapperWidth = document.getElementById('sidenav-wrapper').clientWidth

    let scrollWidthPrev = scrollWidth - wrapperWidth
    if (scrollWidthPrev < 0) {
      setScrollWidth(0)
      setPrevDisable(true)
      setNextDisable(false)
    } else {
      setScrollWidth(scrollWidthPrev)
      setPrevDisable(false)
    }
  }

  useEffect(() => {
    //console.log('active',navigation,activeGroupId)
    if (navigation.length > 0) {
      setActiveGroupId(navigation[navigation.length - 1].id)
      const navbar = document.getElementsByClassName('m-header ')
      const perspectiveHeader =
        document.getElementsByClassName('perspective-header')
      let navigationHeight =
        navbar[0]?.clientHeight + perspectiveHeader[0]?.clientHeight
      setNavigationHeight(navigationHeight)
    }
  }, [navigation])

  const scrollNextHandler = () => {
    const wrapperWidth = document.getElementById('sidenav-wrapper').clientWidth
    const contentWidth =
      document.getElementById('sidenav-horizontal').clientWidth

    let scrollWidthNext = scrollWidth + (wrapperWidth - 80)
    if (scrollWidthNext > contentWidth - wrapperWidth) {
      scrollWidthNext = contentWidth - wrapperWidth + 80

      setScrollWidth(scrollWidthNext)
      setPrevDisable(false)
      setNextDisable(true)
    } else {
      setScrollWidth(scrollWidthNext)
      setPrevDisable(false)
    }
  }

  const toggleGroup = (groupId, item) => {
    if (item.routePath) {
      history.push({ pathname: item.routePath })
    } else {
      dispatch({
        type: actionType.GROUP_MENU_ID,
        groupMenuId: groupMenuId === groupId ? null : groupId,
      })
    }
    setIsToggle(true)
  }

  const [navItems, setNavItems] = useState([])

  useEffect(() => {
    setActiveGroupId(groupMenuId)
  }, [groupMenuId])

  useEffect(() => {
    let activeGroupId = isToggle ? groupMenuId : menuClick?.groupMenuId ?? null
    if (!activeGroupId) {
      activeGroupId = objectPath.get(navigation, [0, 'id'])
    }
    let navItems = navigation.map((item) => {
      switch (item.type) {
        case 'group':
          return (
            <NavGroup
              layout={layout}
              key={'nav-group-' + item.id}
              group={item}
              activeGroupId={activeGroupId}
              onClick={() => toggleGroup(item.id, item)}
            />
          )
        default:
          return false
      }
    })
    setNavItems(navItems)
  }, [JSON.stringify(navigation), groupMenuId, menuClick?.url])

  let scrollStyle = {
    marginLeft: '-' + scrollWidth + 'px',
  }

  if (layout === 'horizontal' && rtlLayout) {
    scrollStyle = {
      marginRight: '-' + scrollWidth + 'px',
    }
  }

  let mainContent = ''
  if (layout === 'horizontal') {
    let prevClass = ['sidenav-horizontal-prev']
    if (prevDisable) {
      prevClass = [...prevClass, 'disabled']
    }
    let nextClass = ['sidenav-horizontal-next']
    if (nextDisable) {
      nextClass = [...nextClass, 'disabled']
    }

    mainContent = (
      <div className="navbar-content sidenav-horizontal" id="layout-sidenav">
        <Link
          to="#"
          className={prevClass.join(' ')}
          onClick={scrollPrevHandler}
        >
          <span />
        </Link>
        <div id="sidenav-wrapper" className="sidenav-horizontal-wrapper">
          <ListGroup
            variant="flush"
            bsPrefix=" "
            as="ul"
            id="sidenav-horizontal"
            className="nav pcoded-inner-navbar sidenav-inner"
            onMouseLeave={() =>
              dispatch({ type: actionType.NAV_CONTENT_LEAVE })
            }
            style={scrollStyle}
          >
            {navItems}
          </ListGroup>
        </div>
        <Link
          to="#"
          className={nextClass.join(' ')}
          onClick={scrollNextHandler}
        >
          <span />
        </Link>
      </div>
    )
  } else {
    mainContent = (
      <div
        className="navbar-content next-scroll"
        style={{ height: `calc(100% - ${navigationHeight}px)` }}
      >
        <PerfectScrollbar>
          <ListGroup
            variant="flush"
            as="ul"
            bsPrefix=" "
            className="nav pcoded-inner-navbar"
            id="nav-ps-next"
          >
            {navItems}
          </ListGroup>
        </PerfectScrollbar>
      </div>
    )
  }

  return <React.Fragment>{mainContent}</React.Fragment>
}

export default NavContent
